import React from 'react';
import { Breakpoint } from './Breakpoint';

interface IProps {}

export const Desktop = (props: React.PropsWithChildren<IProps>): JSX.Element => {
  return <Breakpoint name="desktop">{props.children}</Breakpoint>;
};
